import { render, staticRenderFns } from "./BigContentViewer.vue?vue&type=template&id=4e9ba5f4&scoped=true&"
import script from "./BigContentViewer.vue?vue&type=script&lang=js&"
export * from "./BigContentViewer.vue?vue&type=script&lang=js&"
import style0 from "./BigContentViewer.vue?vue&type=style&index=0&id=4e9ba5f4&prod&lang=scss&scoped=true&"
import style1 from "./BigContentViewer.vue?vue&type=style&index=1&id=4e9ba5f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9ba5f4",
  null
  
)

export default component.exports